<template>
<el-container class="f-h">
    <el-header class="toolbar" style="height: 5.5rem">
        <el-row type="flex" justify="space-between">
            <div class="sub-title">
                挂号类别：
                <el-button type="primary" size="small" icon="el-icon-document-add" @click="create" v-if="permission.registration_type_create">新建</el-button>
            </div>
        </el-row>
        <el-tabs v-model="meta.itemType" @tab-click="queryEntities">
            <el-tab-pane label="挂号类别" name="挂号类别"></el-tab-pane>
            <el-tab-pane label="费用标准" name="费用标准"></el-tab-pane>
        </el-tabs>
    </el-header>
    <el-main style="padding: 0px;">
        <el-table v-if="meta.itemType=='挂号类别'" @sort-change="handleSortChange" v-loading='meta.loading' :data="entities.items" class="main-table" height="91%">
            <el-table-column sortable="custom" label="名称" prop="name"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="permission.registration_type_update">
                        <el-button type="primary" plain size="mini" circle icon="el-icon-edit" @click="edit(scope.row)"></el-button>
                    </span>
                    <span v-else>
                        <el-button type="primary" plain size="mini" circle icon="el-icon-edit" title="无权限" disabled></el-button>
                    </span>
                    <el-popconfirm title="确定要删除吗?" icon-color="red" @confirm="del(scope.row)" class="left-pad" v-if="permission.registration_type_delete">
                        <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="序号" prop="seqNo" align="center"></el-table-column>
            <el-table-column sortable="custom" label="编码" prop="code"></el-table-column>
            <el-table-column sortable="custom" label="单价" prop="price" align="right" width="100">
                <template slot-scope="scope">
                    {{ scope.row.price | fmtFloat(2) }}
                </template>
            </el-table-column>

            <el-table-column sortable="custom" min-width="100" label="号源排班" prop="rotaType" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.rotaType=='急诊'">即时生成</span>
                    <span v-else>{{scope.row.rotaType}}</span>
                </template>
            </el-table-column>

            <el-table-column label="备注" prop="memo"></el-table-column>
            <el-table-column sortable="custom" label="停用" prop="disabled">
                <template slot-scope="scope">
                    <span v-if="scope.row.disabled">是</span>
                </template>
            </el-table-column>
        </el-table>
        <el-table v-if="meta.itemType=='费用标准'" @sort-change="handleSortChange" v-loading='meta.loading' :data="entities.items" class="main-table" height="91%">
            <el-table-column sortable="custom" label="名称" prop="name"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="permission.registration_type_update">
                        <el-button type="primary" plain size="mini" circle icon="el-icon-edit" @click="edit(scope.row)"></el-button>
                    </span>
                    <span v-else>
                        <el-button type="primary" plain size="mini" circle icon="el-icon-edit" title="无权限" disabled></el-button>
                    </span>
                    <el-popconfirm title="确定要删除吗?" icon-color="red" @confirm="del(scope.row)" class="left-pad" v-if="permission.registration_type_delete">
                        <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="编码" prop="code" width="120"></el-table-column>
            <el-table-column sortable="custom" label="医保" prop="insuranceCode" width="120"></el-table-column>
            <el-table-column sortable="custom" label="单价" prop="price" width="100" align="right">
                <template slot-scope="{row}">
                    {{ row.price | fmtFloat(2) }}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="单位" prop="unit" width="80" align="center" >
                <template slot-scope="{row}">
                    {{ row.unit}}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="费用类型" prop="feeType" width="100">
                <template slot-scope="{row}">
                    {{ row.feeType | dictText("FeeType") }}
                </template>
            </el-table-column>
            <el-table-column label="包含" prop="include">
                <template slot-scope="{row}">
                    {{ row.include }}
                </template>
            </el-table-column>
            <el-table-column label="除外" prop="exclude"></el-table-column>
            <el-table-column label="备注" prop="memo"></el-table-column>
            
        </el-table>
    </el-main>
    <pagination :entities='entities' @queryEntities='queryEntities' :condition='condition' />
    <editor v-model="entity" :visible.sync="meta.showEditor" @saved="queryEntities"></editor>
    <feeEditor v-model="entity" :visible.sync="meta.showFeeEditor" @saved="queryEntities"></feeEditor>
</el-container>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";
export default {
    components: {
        editor: () => import("./editor"),
        feeEditor: () => import("./editorFee"),
        pagination: () => import("@/components/_com/pagination")
    },
    data() {
        return {
            meta: {
                showEditor: false,
                showFeeEditor: false,
                loading: false,
                itemType: "挂号类别"
            },
            condition: {
                pageIndexOnView: 1,
                pageSize: 20,
                sort: "id",
                asc: false,
            },
            entities: {
                items: []
            },
            entity: {}
        };
    },
    computed: {
        ...mapGetters(["permission"]),
    },
    created() {
        this.queryEntities();
    },
    methods: {
        handleSortChange({ prop, order }) {
            this.condition.asc = order === "ascending";
            this.condition.sort = prop;
            this.queryEntities();
        },
        create() {
            if (this.meta.itemType == "挂号类别") {
                this.entity = { id: null, rotaType: '科室' };
                this.$nextTick(() => {
                    this.meta.showEditor = true;
                });
            }
            if (this.meta.itemType == "费用标准") {
                this.entity = { id: null };
                this.$nextTick(() => {
                    this.meta.showFeeEditor = true;
                });
            }
            
        },
        edit(row) {
            this.entity = JSON.parse(JSON.stringify(row));
            this.$nextTick(() => {
                if (this.meta.itemType == "挂号类别") {
                    this.meta.showEditor = true;
                }
                if (this.meta.itemType == "费用标准") {
                    this.meta.showFeeEditor = true;
                }

            });
        },
        del(row) {
            let _this = this;
            if (this.meta.itemType == "挂号类别") {
                api.delRegType(row.id).then(
                    res => {
                        _this.queryEntities();
                        this.$store.dispatch("unloadDicts", ["RegType"]);
                        this.$store.dispatch("loadDicts", ["RegType"]);
                    },
                    msg => {
                        _this.$message({
                            type: "error",
                            message: msg
                        });
                    }
                );
            }
            if (this.meta.itemType == "费用标准") {
                api.delFeeStandard(row.id).then(
                    res => {
                        _this.queryEntities();
                    },
                    msg => {
                        _this.$message({
                            type: "error",
                            message: msg
                        });
                    }
                );
            }
        },
        queryEntities() {
            this.meta.loading = true;
            if (this.meta.itemType == "挂号类别") {
                api
                .queryRegTypes(this.condition)
                .then(res => {
                    this.$set(this, "entities", res);
                })
                .catch(reason => {
                    console.log("号别查询错误:", reason);
                }).finally(() => {
                    this.meta.loading = false;
                })
            }
            
            if (this.meta.itemType == "费用标准") {
                api
                .queryFeeStandard(this.condition)
                .then(res => {
                    this.$set(this, "entities", res);
                })
                .catch(reason => {
                    console.log("费用标准查询错误:", reason);
                }).finally(() => {
                    this.meta.loading = false;
                })
            }
        }
    },
};
</script>

<style scoped>
</style>
